import { safeConcatWith } from './safeConcat';

type CreateDataTestIdProps = {
  inputString: string;
  prefix?: string;
  suffix?: string;
};

export const createDataTestId = ({ inputString, prefix, suffix }: CreateDataTestIdProps) => {
  if (inputString == null) return '';

  const formattedString = inputString.toLowerCase().replaceAll(' ', '-').replaceAll('_', '-');

  return safeConcatWith('-')(prefix, formattedString, suffix);
};
